import React from "react";
import RiskBanner from "@/components/RiskBanner";

function cellColor(tone) {
  if (tone === "pos") return "text-[#00e676]";
  if (tone === "neg") return "text-[#ff3b30]";
  return "text-white";
}

function Cell({ label, value, tone }) {
  return (
    <div className="bg-[#0f0f0f] p-4">
      <div className="micro-label">{label}</div>
      <div className={`font-mono-data text-xl mt-1 ${cellColor(tone)}`}>{value}</div>
    </div>
  );
}

function tradeTone(ret) {
  return ret >= 0 ? "pos" : "neg";
}

export default function BacktestResults({ result }) {
  const winTone = result.win_rate >= 50 ? "pos" : "neg";
  const avgTone = result.avg_return >= 0 ? "pos" : "neg";
  return (
    <div data-testid="bt-result">
      <RiskBanner variant="backtest" />
      <div className="panel mt-2">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-[#222] border-b border-[#222]">
          <Cell label="TRADES" value={result.n} />
          <Cell label="WIN RATE" value={result.win_rate + "%"} tone={winTone} />
          <Cell label="AVG RETURN" value={result.avg_return + "%"} tone={avgTone} />
          <Cell label="BEST" value={(result.best || 0) + "%"} tone="pos" />
          <Cell label="WORST" value={(result.worst || 0) + "%"} tone="neg" />
        </div>
        <table className="w-full text-sm">
          <thead className="bg-[#0a0a0a]">
            <tr>
              <th className="px-3 py-2 micro-label text-left">DATE</th>
              <th className="px-3 py-2 micro-label text-right">ENTRY</th>
              <th className="px-3 py-2 micro-label text-right">EXIT</th>
              <th className="px-3 py-2 micro-label text-right">RETURN %</th>
            </tr>
          </thead>
          <tbody>
            {result.trades.map((t) => (
              <tr key={t.date} className="border-b border-[#1a1a1a]">
                <td className="px-3 py-1.5 font-mono-data">{t.date}</td>
                <td className="px-3 py-1.5 text-right font-mono-data">${t.entry}</td>
                <td className="px-3 py-1.5 text-right font-mono-data">${t.exit}</td>
                <td className={`px-3 py-1.5 text-right font-mono-data ${tradeTone(t.ret_pct)}`}>
                  {t.ret_pct >= 0 ? "+" : ""}{t.ret_pct}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
